/* eslint-disable arrow-body-style */

import { formatDateStr } from '@gp/utils/common';
import { MilestoneDateStatus } from '@gp/enums/milestone';
import { MILESTONE_CORRECT_NAMES, MILESTONE_NAME_ALIAS } from '@gp/constants/const';

/**
 * 获取milestone正确的名称（大小写正确的）
 * @param name milestone名称（数据库保存的，可能有大小写错误）
 * @returns 正确的milestone名称
 */
export const getMilestoneCorrectName = (name?: string): string => {
  if (!name) return '';
  return MILESTONE_CORRECT_NAMES[name] || name || '';
};

/**
 * 获取milestone名称 对应的 最新的名称
 * @param name milestone名称（别名、曾用名）
 * @returns milestone名称 对应的 最新的名称
 */
export const getMilestoneLatestedName = (name?: string): string => {
  if (!name) return '';
  return MILESTONE_NAME_ALIAS[name] || name || '';
};

/**
 * 格式化milestone的date
 * @param date milestone date
 * @param isTBC 是否为TBC
 * @param notTBCDatePattern 非TBC的日期格式
 * @returns milestone date（格式化后的）
 */
export const formatMilestoneDate = (date?: string, isTBC?: boolean, notTBCDatePattern = 'YYYY-MM-DD'): string => {
  if (!date) return '';
  const datePattern = !!isTBC ? 'YYYY-MM' : notTBCDatePattern;
  return formatDateStr(date, datePattern);
};

/**
 * 格式化milestone的date
 * @param date milestone date
 * @param dateStatus milestone date状态
 * @returns milestone date（格式化后的）
 */
export const formatMilestoneDateByStatus = (date?: string, dateStatus?: MilestoneDateStatus | null): string => {
  return formatMilestoneDate(date, dateStatus === MilestoneDateStatus.ToBeConfirm);
};
